import { initializeDB } from '../config/db';
import { CHANGE_ORDER_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

export const changeOrderService = {
    async submit(changeOrder) {
        try {
            const response = await axiosInstance.post('/change-order/submit', changeOrder);
            return response.data;
        } catch (error) {
            console.error('Error submitting change order:', error);
            throw error;
        }
    },


    async saveToIndexedDB(formData) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(CHANGE_ORDER_STORE, 'readwrite');
            const store = tx.objectStore(CHANGE_ORDER_STORE);

            const dataToSave = {
                ...formData,
                updatedAt: new Date().toISOString()
            };

            if (!dataToSave.createdAt) {
                dataToSave.createdAt = new Date().toISOString();
            }

            await store.put(dataToSave);
            await tx.done;
            
            return dataToSave;
        } catch (error) {
            console.error('Error saving to IndexedDB:', error);
            throw error;
        }
    },

    async getFromIndexedDB(uuid) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(CHANGE_ORDER_STORE, 'readonly');
            const store = tx.objectStore(CHANGE_ORDER_STORE);
            const data = await store.get(uuid);
            await tx.done;
            return data;
        } catch (error) {
            console.error('Error getting from IndexedDB:', error);
            throw error;
        }
    },

    async getAllFromIndexedDB() {
        try {
            const db = await initializeDB();
            const tx = db.transaction(CHANGE_ORDER_STORE, 'readonly');
            const store = tx.objectStore(CHANGE_ORDER_STORE);
            const data = await store.getAll();
            await tx.done;
            return data || [];
        } catch (error) {
            console.error('Error getting all from IndexedDB:', error);
            return [];
        }
    },

    async deleteFromIndexedDB(uuid) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(CHANGE_ORDER_STORE, 'readwrite');
            const store = tx.objectStore(CHANGE_ORDER_STORE);
            await store.delete(uuid);
            await tx.done;
        } catch (error) {
            console.error('Error deleting from IndexedDB:', error);
            throw error;
        }
    }
};

